<template>
    <client-page>
        <section class="section">
            <v-container>
                <recruitment-view-card v-bind="{ recruitment }" v-on="{ init }" />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import api from "@/api";
import { initRecruitment } from "@/assets/variables";

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import RecruitmentViewCard from "@/components/client/recruitments/view/recruitment-view-card.vue";

export default {
    components: {
        ClientPage,
        RecruitmentViewCard,
    },
    props: {
        _recruitment: { type: String },
    },
    data: () => ({
        recruitment: initRecruitment(),
    }),
    mounted() {
        this.init();
    },
    watch: {
        _recruitment() {
            this.init();
        },
    },
    methods: {
        async init() {
            this.recruitment = initRecruitment((await api.v1.recruitments.get({ _id: this._recruitment, headers: { hit: true } }))?.recruitment);
        },
    },
};
</script>

<style></style>
